import Axios from 'axios'
import appconst from './appconst'
import Vue from 'vue'
import { Loading, Message } from 'element-ui';
import { showTips } from './message';
import {router} from '../router/index';

const axios = Axios.create({
    baseURL: XMLHTTP_BASEURL,
    timeout: 300000,
    headers: {'Access-Control-Allow-Origin': '*'}
});
axios.interceptors.request.use(function (config) {
    if(!!window.abp.auth.getToken()){
        config.headers.common["Authorization"]="Bearer "+window.abp.auth.getToken();
    }
    config.headers.common[".AspNetCore.Culture"]=window.abp.utils.getCookieValue("Abp.Localization.CultureName");
    // config.headers.common["Abp.TenantId"]=window.abp.multiTenancy.getTenantIdCookie();
    return config;
  }, function (error) {
    return Promise.reject(error);
});
axios.interceptors.response.use((respon)=>{
    if(respon.data.result && respon.data.result.message){
        showTips(respon.data.result.message,respon.data.result.code == 2000?'success':'error',2000);
    }
    endLoading()
    return respon
},(error)=>{
    setTimeout(() => {
        if (error.response) {
            var errLevel = 'error';
            switch (error.response.status) {
                case 401:
                    errLevel = 'warning';
                    error.message = '登陆信息已过期,请重新登陆';
                    // 401 清除token信息并跳转到登录页面
                    router.replace({
                        path: 'login'
                    });
                    break;
                case 403:
                    errLevel = 'warning';
                    error.message = '403:很抱歉,您没有访问权限...';
                    break;
                case 404:
                    error.message = '404:很抱歉,您访问地址出错了...';
                    break;
                case 500:
                    if(!!error.response&&!!error.response.data.error&&!!error.response.data.error.message&&error.response.data.error.details){
                        if (error.response.data.error.message !== "[Login failed]"){
                            errLevel = 'error';
                            error.message = error.response.data.error.details;
                            router.replace({
                                path: 'login'
                            });
                        }
                    }else if(!!error.response&&!!error.response.data.error&&!!error.response.data.error.message){
                        error.message = '500:很抱歉,服务器出错了...';
                    }else if(!error.response){
                        error.message = '500:很抱歉,服务器出错了...';
                    }
                    break;
            }
        }
        showTips(error.message, errLevel,2000);
        endLoading()
        return Promise.reject(error);
    },100)
    return Promise.reject(error);
})
let loading;
function startLoading (flag:boolean) {
    if(flag){
        loading = Loading.service({
            text: '加载中...',
            lock: true,
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        })
    }
}
function endLoading() {
    if(loading){
        loading.close()
    }
}
/**
 * 网络请求
 * @param url
 * @param params
 * @param loading (查询类，传参false,无loading。操作类如新增，编辑等，loading=true防误触))
 * @returns promise
 */
class ajax {
    static async get(url:string,params:object={},loading:boolean=true) {
      startLoading(loading)
      return await axios.get(url,params)
    }
    static async post(url:string,params:object={},loading:boolean=true) {
      startLoading(loading)
      return await axios.post(url,params);
    }
    static async put(url:string,params:object={},loading:boolean=true) {
        startLoading(loading)
        return await axios.put(url,params);
    }
    static async delete(url:string,params:object={},loading:boolean=true) {
        startLoading(loading)
        return await axios.delete(url,params);
    }
}
export default ajax;

